// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2ZtSD","name":"Header_name__1NJUs","github":"Header_github__1sRkW","link":"Header_link__NFLNH"};